import { Link } from 'react-router';

export default function NotFoundPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: 'var(--gradient-page)',
        padding: 24,
        textAlign: 'center',
        fontFamily: 'var(--font-body)',
      }}
    >
      <div>
        <h1 style={{ fontSize: 48, margin: '0 0 12px' }}>404</h1>
        <p style={{ fontSize: 18, color: 'var(--text-body)', margin: '0 0 24px' }}>
          Siden blev ikke fundet.
        </p>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            background: 'var(--blue-600)',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: 'var(--radius-pill)',
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
